import React, { useState, createContext } from "react";

export const AppSelectShopContext = createContext()

export const AppSelectShopContextProvider = (props) => {
  const [appSelectShopName, setAppSelectShopName] = useState();
  const [appSelectShopId, setAppSelectShopId] = useState();

  const [appSelectBrandName, setAppSelectBrandName] = useState();
  const [appSelectBrandId, setAppSelectBrandId] = useState();

  return (
    <AppSelectShopContext.Provider
      value={{
        appSelectShopName, setAppSelectShopName,
        appSelectShopId, setAppSelectShopId,
        appSelectBrandName, setAppSelectBrandName,
        appSelectBrandId, setAppSelectBrandId
      }}
    >
      {props.children}
    </AppSelectShopContext.Provider>
  )
}